import React from "react";
import C2bTradein from "../../components/trade-in-wrapper";

const CheckoutPage = () => {
    return (
        <React.Fragment>
            <C2bTradein />
        </React.Fragment>
    );
};

export default CheckoutPage;
